import React, { memo } from 'react';
import MarkdownToJsx from 'markdown-to-jsx';
import markdownNativeComponents from './markdownComponents';
import style from './index.module.scss';

const CMarkdown = ({
  content,
  onClick = (content) => { },
  outputStatus = '',
  ...props
}) => {
  // 处理内容，保护表格格式
  const cleanMarkdown = (content) => {
    if (!content) return '';
    let result = content
      // 1. 先处理 strong 标签中的链接（在移除 font 之前）
      .replace(/<strong><a href="([^"]*)"[^>]*>([^<]*)<\/a><\/strong>/g, '**[$2]($1)**')
      
      // 2. 处理普通链接（在移除 font 之前）
      .replace(/<a href="([^"]*)"[^>]*>([^<]*)<\/a>/g, '[$2]($1)')
      
      // 3. 修复 strong 标签嵌套（确保正确闭合，但不包含链接的）
      .replace(/<strong>([^<]*)<\/strong>/g, '**$1**')
      
      // 4. 移除 font 标签，但保留内容（需要处理嵌套的 markdown 链接和 strong）
      // 先处理 font 标签内包含 strong+链接的情况（已经在前面的步骤转换过了）
      .replace(/<font[^>]*>\*\*\[([^\]]+)\]\(([^)]+)\)\*\*<\/font>/g, '**[$1]($2)**')
      // 再处理 font 标签内包含链接的情况
      .replace(/<font[^>]*>\[([^\]]+)\]\(([^)]+)\)<\/font>/g, '[$1]($2)')
      // 再处理 font 标签内包含 strong 的情况
      .replace(/<font[^>]*>\*\*([^*]+)\*\*<\/font>/g, '**$1**')
      // 最后移除所有剩余的 font 标签（保留内容）
      .replace(/<font[^>]*>/g, '')
      .replace(/<\/font>/g, '')
      
      // 5. 修复标题格式（移除标题中的 | 符号）
      .replace(/##### \|/g, '#####')
      
      // 6. 修复链接中的转义字符
      .replace(/\\"/g, '"')
      
      // 7. 清理行首和行尾的多余空格（但不影响表格的分隔符 |）
      .replace(/[ \t]+$/gm, '')
      .replace(/^[ \t]+/gm, '')
      // 8. 修复表格格式（以前表格格式是 ：\n\| ，现在修复为：\n\n| ）
      .replace(/：\n\| /g, '：\n\n| ');

    // 9. 专门处理表格格式：移除表格行之间的空行，但保留其他内容的空行
    // 识别表格块：连续的多行，每行都以 | 开头
    const lines = result.split('\n');
    const processedLines = [];
    let inTable = false;
    
    // 辅助函数：判断是否是表格行
    const isTableLine = (line) => {
      const trimmed = line.trim();
      // 表格行必须以 | 开头，并且包含至少两个 |
      return trimmed.startsWith('|') && trimmed.split('|').length >= 3;
    };
    
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      
      if (isTableLine(line)) {
        // 这是表格行
        if (!inTable) {
          // 进入表格块
          inTable = true;
        }
        processedLines.push(line);
      } else if (line.trim() === '') {
        // 空行处理
        if (inTable) {
          // 在表格块中遇到空行，检查下一行是否还是表格行
          let nextNonEmptyLineIndex = i + 1;
          while (nextNonEmptyLineIndex < lines.length && lines[nextNonEmptyLineIndex].trim() === '') {
            nextNonEmptyLineIndex++;
          }
          const nextNonEmptyLine = nextNonEmptyLineIndex < lines.length ? lines[nextNonEmptyLineIndex] : '';
          
          if (isTableLine(nextNonEmptyLine)) {
            // 下一行是表格行，跳过这个空行（不添加），保持表格块连续
            continue;
          } else {
            // 下一行不是表格行，表格块结束
            inTable = false;
            processedLines.push(line);
          }
        } else {
          // 不在表格中，保留空行
          processedLines.push(line);
        }
      } else {
        // 非表格行，非空行
        if (inTable) {
          // 表格块结束
          inTable = false;
        }
        processedLines.push(line);
      }
    }
    
    result = processedLines.join('\n');
    
    // 9. 最后清理连续的多个空行（保留最多2个空行用于内容间隔）
    result = result.replace(/\n{4,}/g, '\n\n\n');
    
    return result;
  };

  return (
    <MarkdownToJsx
      {...props}
      options={{
        overrides: {
          ...markdownNativeComponents({ from: props.from, requestId: props.requestId, outputStatus }),
          QA: {
            // eslint-disable-next-line no-shadow
            component: (props) => (
              <p
                style={{ color: '#2656F6', cursor: 'pointer' }}
                {...props}
                className={style.p}
                onClick={() => onClick?.(content)}
              />
            ),
          },
        },
      }}
      className={`${style.markdownContainer} ${props.className}`}
    >
      {cleanMarkdown(content)}
    </MarkdownToJsx>
  );
};

export default memo(CMarkdown);
